import { BaseTranslator } from '../base';

import vi from './languages/vi.json';
import en from './languages/en.json';
import zh from './languages/zh.json';
import id from './languages/id.json';
import th from './languages/th.json';
import { ITranslatorParams, LangService } from '@totoplay/toto-core-utilities';

export type TCommonLanguageTokens = keyof typeof vi;

export class Common extends BaseTranslator {
  private static _instance: Common;

  public static instance() {
    if (!Common._instance) {
      Common._instance = new Common();
    }

    return Common._instance;
  }

  protected override builder(): void {
    this.namespace = LangService.instance().getCommonNamespace();
    this.setResources([
      {
        language: 'vi',
        resource: vi,
      },
      {
        language: 'en',
        resource: en,
      },
      {
        language: 'zh',
        resource: zh,
      },
      {
        language: 'id',
        resource: id,
      },
      {
        language: 'th',
        resource: th,
      },
    ]);
  }

  public getCountryToken(countryId?: string) {
    return `common.country.${countryId?.toUpperCase()}`;
  }

  public getDateOfWeekToken(day?: number) {
    return `common.date.week.${day}`;
  }

  public getCategoryToken(countryId?: string, categoryId?: string) {
    return `lottery.category.${countryId?.toUpperCase()}.${categoryId?.toUpperCase()}`;
  }

  public getSchedulerToken(schedulerId?: string) {
    return `lottery.scheduler.${schedulerId}`;
  }

  public getPrizePositionToken(prizePosition?: number) {
    return `lottery.prize.position.${prizePosition}`;
  }

  public translateError(message?: number | string | ITranslatorParams): string {
    const ns = this.getNameSpace();

    return !message
      ? LangService.instance().translate('error.1', { ns })
      : typeof message !== 'object'
      ? LangService.instance().translate(`error.${message}`, { defaultValue: message, ns })
      : LangService.instance().translate(`error.${message.key}`, {
          ns,
          ...LangService.instance().parseOptions(message.options),
        });
  }

  public translateSuccess(message?: number | string | ITranslatorParams): string {
    const ns = this.getNameSpace();
    return !message
      ? LangService.instance().translate('success.1', { ns })
      : typeof message !== 'object'
      ? LangService.instance().translate(`success.${message}`, { defaultValue: message, ns })
      : LangService.instance().translate(`success.${message.key}`, {
          ns,
          ...LangService.instance().parseOptions(message.options),
        });
  }

  public translateWarning(message?: number | string | ITranslatorParams): string {
    const ns = this.getNameSpace();
    return !message
      ? LangService.instance().translate('warning.1', { ns })
      : typeof message !== 'object'
      ? LangService.instance().translate(`warning.${message}`, { defaultValue: message, ns })
      : LangService.instance().translate(`warning.${message.key}`, {
          ns,
          ...LangService.instance().parseOptions(message.options),
        });
  }
}

// always init a default instance
Common.instance();
